/*
 * ////////////////////////////////////////////////////////////////////////////////
 * //
 * // This software system consists of computer software and documentation.
 * // It contains trade secrets and confidential information which are proprietary
 * // to Everi Games Inc.  Its use or disclosure in whole or in part without
 * // the express written permission of Everi Games Inc. is prohibited.
 * //
 * // This software system is also an unpublished work protected under the copyright
 * // laws of the United States of America.
 * //
 * // Copyright © 2018 Everi Games Inc.  All Rights Reserved
 * //
 * ////////////////////////////////////////////////////////////////////////////////
 */
import MutatorComponentBase from './MutatorComponentBase';

/** @hidden */
// tslint:disable-next-line:typedef
const property = cc._decorator.property;

@cc._decorator.ccclass
export default class NodePropertiesMutator extends MutatorComponentBase
{
    @property(cc.Float)
    protected threshold: number = .0001;

    @property(cc.Node)
    protected topNode: cc.Node = null;

    @property()
    public get Execute(): boolean { return false; }
    public set Execute(value: boolean)
    {
        this.execute(this.topNode, [this.nodeHandler.bind(this)]);
    }

    @property([cc.String])
    protected nodeProperties: string[] =
    [
        'position.x',
        'position.y',
        'rotation',
        'scaleX',
        'scaleY',
        'anchorX',
        'anchorY',
        'width',
        'height',
        'opacity',
        'skewX',
        'skewY'
    ];

    // #region AssetScalar Configuration Helpers

    private nodeHandler(target: cc.Node): boolean
    {
        let success: boolean = false ;

        this.nodeProperties.forEach(prop =>
        {
            let currentTarget: any = target;
            let props: string[] = prop.split('.');

            if (props.length > 1)
            {
                for (let count: number = 0; count < props.length; count++)
                {
                    if (count < props.length - 1)
                    {
                        currentTarget = currentTarget[props[count]];

                        if (currentTarget === undefined)
                        {
                            this.warn(target, `Invalid property [${prop}].`);
                            return;
                        }

                        continue;
                    }

                    prop = props[count];
                }
            }

            let ratio: number = Math.floor(1 / this.threshold);
            let value: number = currentTarget[prop];
            let thresholdValue: number = Math.floor(value * ratio) / ratio;

            let thisSuccess: boolean = value !== thresholdValue
                && value.toString().length > thresholdValue.toString().length;

            if (thisSuccess)
            {
                this.warn(target, `Property: [${prop}] Value: [${currentTarget[prop]}] TValue: [${thresholdValue}]`);
                if (this.shouldModify)
                {
                    currentTarget[prop] = thresholdValue;
                    this.warn(target, `FIXED - Property [${prop}] set to [${currentTarget[prop]}]`);
                }
            }

            success = success || thisSuccess;
        }, this);

        return success;
    }

    // #endregion
}
